// extracted by mini-css-extract-plugin
export default {"menu":"EditMenu_menu__uGNiX","dark":"EditMenu_dark__f8yHU","active":"EditMenu_active__jVPtL"};